import { useEffect, useState } from 'react';

/**
 * 倒计时 hook：返回剩余毫秒（≥ 0）。deadlineTs 为 null 时返回 null。
 */
export function useCountdown(deadlineTs: number | null, tickMs = 250): number | null {
  const [remaining, setRemaining] = useState<number | null>(() =>
    deadlineTs == null ? null : Math.max(0, deadlineTs - Date.now()),
  );

  useEffect(() => {
    if (deadlineTs == null) {
      setRemaining(null);
      return;
    }
    setRemaining(Math.max(0, deadlineTs - Date.now()));
    const id = setInterval(() => {
      setRemaining(Math.max(0, deadlineTs - Date.now()));
    }, tickMs);
    return () => clearInterval(id);
  }, [deadlineTs, tickMs]);

  return remaining;
}

export function formatMs(ms: number | null): string {
  if (ms == null) return '--:--';
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
